module.exports = __webpack_public_path__ + "media/images/logo1-9aeb68f6d944bcc18c5f2486d0c32720.png";